import omnitureHelper from 'utils/omnitureHelper';
import { TRACK_LINK } from 'pages/PaymentsPage/Analytics/PaymentsOmnitureConstants';
const AUTH_MODE = '2FA';
const OTPAuth = 'OTPAuthentication';
export var SiteSectionTypes;
(function (SiteSectionTypes) {
    SiteSectionTypes["CnC"] = "2FA:CnC";
    SiteSectionTypes["EGV"] = "2FA:EGV";
})(SiteSectionTypes || (SiteSectionTypes = {}));
var Source;
(function (Source) {
    Source["ORDER_SUMMARY"] = "OrderSummary";
    Source["EGV"] = "EGV";
})(Source || (Source = {}));
export function sendOpen2FA(params) {
    if (!params) {
        return;
    }
    let omniData = {};
    if (params.siteSection === SiteSectionTypes.CnC) {
        omniData.pageName = omniData.eVar50 = `${AUTH_MODE}_${Source.ORDER_SUMMARY}_${OTPAuth}`;
        omniData.pageType = omniData.eVar3 = `${AUTH_MODE}_${OTPAuth}`;
        omniData.eVar7 = 'Checkout:Summary';
        omniData.prop25 = 'Checkout';
        omniData.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
        omniData.events = ''; // Have to send empty string. If not sent then `undefined` getting prepended to events string.
        omnitureHelper.trackOmniturePageView(omniData);
    }
    else if (params.siteSection === SiteSectionTypes.EGV) {
        omniData.pageName = omniData.eVar50 = TRACK_LINK.VALUES.PAGE_NAME;
        omniData.pageType = omniData.eVar3 = TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT;
        omniData.prop24 = 'EGV_verify_OTP_clicked';
        omnitureHelper.trackLink(omniData, `2FA_EGV_OTPAuthentication`);
    }
}
export function sendDismissOtp(params) {
    if (!params) {
        return;
    }
    if (params.siteSection === SiteSectionTypes.EGV) {
        return;
    }
    let omniFields = {};
    omniFields.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
    omniFields.events = 'event361';
    omnitureHelper.trackLink(omniFields, `${AUTH_MODE}_${Source.ORDER_SUMMARY}_${OTPAuth}_Dismiss`);
}
export function sendOtpEntered(params) {
    if (!params) {
        return;
    }
    if (params.siteSection === SiteSectionTypes.EGV) {
        return;
    }
    let omniFields = {};
    omniFields.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
    omniFields.events = 'event359';
    omnitureHelper.trackLink(omniFields, `${AUTH_MODE}_${Source.ORDER_SUMMARY}_OTP_Manual`);
}
export function sendCorrectOtpEntered(params) {
    if (!params) {
        return;
    }
    let omniFields = {};
    let customLink = '';
    if (params.siteSection === SiteSectionTypes.CnC) {
        omniFields.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
        omniFields.events = 'event463';
        customLink = `${AUTH_MODE}_${Source.ORDER_SUMMARY}_Correct_OTP_Entered`;
    }
    else if (params.siteSection === SiteSectionTypes.EGV) {
        omniFields.pageName = omniFields.eVar50 = TRACK_LINK.VALUES.PAGE_NAME;
        omniFields.pageType = omniFields.eVar3 = TRACK_LINK.VALUES.PAGE_TYPE_DEFAULT;
        omniFields.prop24 = 'EGV_OTP_entered';
        omniFields.events = 'event359';
        customLink = `${AUTH_MODE}_${Source.EGV}_OTP_Manual_complete`;
    }
    omnitureHelper.trackLink(omniFields, customLink);
}
export function sendIncorrectOtpEntered(params) {
    if (!params) {
        return;
    }
    let omniFields = {};
    let customLink = '';
    if (params.siteSection === SiteSectionTypes.CnC) {
        omniFields.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
        omniFields.events = 'event360';
        customLink = `${AUTH_MODE}_${Source.ORDER_SUMMARY}_Incorrect_OTP_Entered`;
    }
    else if (params.siteSection === SiteSectionTypes.EGV) {
        omniFields.pageName = omniFields.eVar50 = 'Checkout:Payment';
        omniFields.pageType = omniFields.eVar3 = 'Checkout';
        omniFields.prop24 = 'EGV_incorrect_OTP_Entered';
        omniFields.events = '';
        customLink = `${AUTH_MODE}_${Source.EGV}_Incorrect_OTP_Entered`;
    }
    omnitureHelper.trackLink(omniFields, customLink);
}
export function sendOtpResend(params) {
    if (!params) {
        return;
    }
    let omniFields = {};
    let customLink = '';
    if (params.siteSection === SiteSectionTypes.CnC) {
        omniFields.eVar1 = params.siteSection; // setting eVar1 since prop1 gets overwritten with eVar1 value
        omniFields.events = 'event362';
        customLink = `${AUTH_MODE}_${Source.ORDER_SUMMARY}_Resend_OTP`;
    }
    else if (params.siteSection === SiteSectionTypes.EGV) {
        omniFields.pageName = omniFields.eVar50 = 'Checkout:Payment';
        omniFields.pageType = omniFields.eVar3 = 'Checkout';
        omniFields.prop24 = 'EGV_resend_OTP_Clicked';
        omniFields.events = 'event362';
        customLink = `${AUTH_MODE}_${Source.EGV}_resend_OTP_Clicked`;
    }
    omnitureHelper.trackLink(omniFields, customLink);
}
